import styled, { css } from "styled-components";
import DocumentPreview, {
  DocumentPreviewPlaceholder,
  useDocumentPreview,
} from "../../../contract/preview/DocumentPreview";
import { onDesktop } from "@teamscheme/theme";
import FlyoutModal from "@teamscheme/flyout-modal";

export interface PreviewModalProps {
  isOpen: boolean;
  onClose(): void;
}

const PreviewMenuModal = styled(FlyoutModal)`
  width: 100%;
`;

const ModalDocumentPreview = styled(DocumentPreview)`
  ${({ theme }) => css`
    width: auto;
    max-width: initial;
    margin: 0 -${theme.spacing.space24};

    ${onDesktop`
      margin: 0 -${theme.spacing.space48};
    `}

    .DocumentPreview {
      box-shadow: none;
      border: 1px solid ${theme.nafColor.neutral.neutral2};
    }
  `}
`;

function LoadDocumentPreview() {
  const documentPreview = useDocumentPreview();

  return (
    <ModalDocumentPreview
      loading={documentPreview.loading}
      result={documentPreview.result!}
    />
  );
}

export default function PreviewModal({ isOpen, onClose }: PreviewModalProps) {
  return (
    <PreviewMenuModal isOpen={isOpen} onClose={onClose}>
      {isOpen ? <LoadDocumentPreview /> : <DocumentPreviewPlaceholder />}
    </PreviewMenuModal>
  );
}
